import React, { useState } from 'react';
import { Box, Typography, IconButton, Tooltip, Divider } from '@mui/material';
import { ExpandMore, ChevronRight } from '@mui/icons-material';
import beautify from 'xml-beautifier';
import CopyIcon from '../../../../assets/icons/copy-icon';
import JSONViewer from '../../../json-viewer';
import theme from '../../../../globals/theme';

const tooltipCopied = 'copied to clipboard';

type TextAreaCopyType = {
  title: string;
  content: string;
  contentType?: string;
  updateHeight: Function;
};
const TextAreaCopy = ({ title, content, contentType, updateHeight }: TextAreaCopyType) => {
  const contentWithRemovedQuotes = content[0] === '"' ? content.slice(1, -1) : content;
  const [tooltipText, setTooltipText] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const hygienicXml = title === 'Parsed XML' && content.replace(/\\/g, '').replace(`"`, '').replace(`>"`, '>');

  const copyValue = () => {
    navigator.clipboard.writeText(hygienicXml || contentWithRemovedQuotes);
    setTooltipText(true);
    setTimeout(() => {
      setTooltipText(false);
    }, 2000);
  };

  const handleToggleExpanded = () => {
    updateHeight();
    setExpanded(!expanded);
  };

  return (
    <Box pb={1} width="100%">
      <Divider />
      <Box pt={1} display="flex" alignItems="center">
        <Box pr={1}>
          <Typography variant="h6">{title}</Typography>
        </Box>
        <Tooltip open={tooltipText} title={tooltipCopied} placement="top" arrow>
          <IconButton
            style={{ width: '1rem', height: '1rem' }}
            onClick={copyValue}
            aria-label="copyIcon"
            size="large">
            <CopyIcon strokeWidth="3" stroke={theme.palette.grey[500]} height=".9rem" />
          </IconButton>
        </Tooltip>
        <IconButton
          onClick={handleToggleExpanded}
          aria-label="expand"
          style={{ width: '1rem', height: '1rem', marginRight: '1rem' }}
          size="large">
          {expanded ? <ExpandMore /> : <ChevronRight />}
        </IconButton>
      </Box>
      {expanded && (
        <Box px={1} style={{ width: '100%', maxHeight: '200px', overflow: 'auto' }}>
          {contentType === 'xml' && (
            <div>
              <pre>{beautify(contentWithRemovedQuotes)}</pre>
            </div>
          )}
          {contentType === 'json' && <JSONViewer data={contentWithRemovedQuotes} />}
          {contentType !== 'json' && contentType !== 'xml' && (
            <Typography>{contentWithRemovedQuotes}</Typography>
          )}
        </Box>
      )}
    </Box>
  );
};

export default TextAreaCopy;
